import { z } from "zod"
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "@/hooks/useFilters"

/**
 * Search params schema for stores list
 */
export const storesListSearchSchema = z.object({
  search: z.string().optional().default(""),
  version: z.enum(["unset", "1.0", "2.0"]).optional(),
  pageIndex: z.coerce.number().int().min(0).optional().default(DEFAULT_PAGE_INDEX),
  pageSize: z.coerce.number().int().min(1).max(100).optional().default(DEFAULT_PAGE_SIZE),
  sortBy: z
    .array(z.object({ id: z.string(), desc: z.boolean() }))
    .optional()
    .default([
      { id: "name", desc: false },
      { id: "countryName", desc: false },
      { id: "city", desc: false },
    ]),
})

export type StoresListFilters = z.infer<typeof storesListSearchSchema>
